import React from 'react';
import {
  DEAD_MIN_DAYS,
  EXPIRING_MAX_DAYS,
  EXPIRING_MIN_DAYS,
} from '../utils/portHelpers';

const ITEMS = [
  {
    key: 'unused',
    label: 'Unused',
    description: 'never sent a message',
    badgeClass: 'bg-info text-dark',
    borderColor: '#0dcaf0',
  },
  {
    key: 'expiring',
    label: 'Expiring soon',
    description: `${EXPIRING_MIN_DAYS}–${EXPIRING_MAX_DAYS} days since last message`,
    badgeClass: 'bg-warning text-dark',
    borderColor: '#ffc107',
  },
  {
    key: 'dead',
    label: 'Dead',
    description: `${DEAD_MIN_DAYS}+ days since last message`,
    badgeClass: 'bg-danger',
    borderColor: '#dc3545',
  },
];

/**
 * Summary banner for SIM lifecycle status — surfaces counts staff need to act on.
 */
export default function SimLifecycleBanner({
  lifecycleCounts,
  lifecycleFilter,
  toggleLifecycleFilter,
}) {
  const { unused, expiring, dead } = lifecycleCounts;
  const actionNeeded = unused + expiring + dead;

  if (actionNeeded === 0) {
    return (
      <div
        className="alert alert-success py-2 px-3 mb-3 d-flex align-items-center gap-2"
        style={{ fontSize: '13px' }}
      >
        <span aria-hidden="true">✓</span>
        <span>All SIMs are healthy — no unused, expiring, or dead ports detected.</span>
      </div>
    );
  }

  const activeItem = ITEMS.find((item) => item.key === lifecycleFilter);

  return (
    <div
      className="alert alert-warning py-2 px-3 mb-3"
      style={{ fontSize: '13px', borderLeft: '4px solid #ffc107' }}
      role="status"
    >
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
        <strong>
          {actionNeeded} SIM{actionNeeded === 1 ? '' : 's'} need attention
        </strong>
        {lifecycleFilter && activeItem && (
          <span className="text-muted" style={{ fontSize: '12px' }}>
            Showing: {activeItem.label.toLowerCase()} only
          </span>
        )}
      </div>

      <div className="d-flex flex-wrap gap-2">
        {ITEMS.map(({ key, label, description, badgeClass, borderColor }) => {
          const count = lifecycleCounts[key];
          if (count === 0) return null;

          const isActive = lifecycleFilter === key;

          return (
            <button
              key={key}
              type="button"
              className="btn btn-sm d-flex align-items-center gap-2"
              style={{
                backgroundColor: isActive ? borderColor : '#fff',
                border: `2px solid ${borderColor}`,
                color: key === 'dead' && isActive ? '#fff' : '#212529',
                fontWeight: isActive ? 600 : 500,
              }}
              onClick={() => toggleLifecycleFilter(key)}
              title={`${label}: ${description}. Click to ${isActive ? 'clear' : 'filter'} view.`}
            >
              <span className={`badge ${badgeClass}`}>{count}</span>
              <span>
                {label}
                <span className="text-muted ms-1" style={{ fontSize: '11px' }}>
                  ({description})
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
